import React from 'react';
import classnames from 'classnames';
import './AppButton.scss';

type AppButtonProps = {
  title: string;
  className?: string;
  secondary?: boolean;
  small?: boolean;
  whiteBtn?: boolean;
  onClick?: () => void;
} & React.ComponentPropsWithRef<'button'>;

export const AppButton: React.FC<AppButtonProps> = ({
  title,
  className,
  secondary,
  small,
  whiteBtn,
  ...rest
}) => {
  const classes = classnames(
    'app-button',
    { 'app-button__secondary': secondary },
    { 'app-button__small': small },
    { 'app-button__white-btn': whiteBtn },
    className,
  );
  return (
    <button className={classes} {...rest}>
      {title}
    </button>
  );
};
